const $ = require('jquery');
const forEach = require('lodash.foreach');

const name = getQueryVariable('name');
// const email = getQueryVariable('email');

if (name) {
  $('#name').text(`, ${name}`);
} else {
  $('#name').remove();
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
}

// swap standard error messages for custom ones
// clientside validation doesn't use the custom messages,
// so we update the default message data attribute to the
// custom one
const $fields = $('[data-webform-required-error]');

forEach($fields, item => {
  const realErrorMsg = item.dataset.webformRequiredError;
  item.dataset.msgRequired = realErrorMsg;
});


/*
// removed on 30 Ocotber 2018 by JH in favor CSS :after content because of the multi-step forms

// add in * for required fields since webform doesn't like to add them
const $allInputs = $('[required], [required="true"]');

forEach($allInputs, item => {
  if ($(item).is('input')) {
    $(item).siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }

  if ($(item).is('select')) {
    $(item).siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }

  if ($(item).is('textarea')) {
    $(item).parent().siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }
});

// add in * for required faux-radio fieldset legend elements since webform doesn't like to add them
$('span.fieldset-legend.form-required').append('<span class="required-mark">*</span>');
*/
